import React from 'react';

export const FILE_TYPE_LABELS = {
	SECTION_TITLE: 'Page Type',
	RADIO_GROUP_NAME: 'file-settings-radio',
	RADIO_GROUP_ARIA_LABEL: 'File Settings'
} as const;

export const FILE_TYPE_MORE_INFO = <>Define which page type the crawler should detect.</>;
